import { createVNode as _createVNode, renderSlot as _renderSlot, toDisplayString as _toDisplayString, withModifiers as _withModifiers, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-756f363e")

_pushScopeId("data-v-756f363e")
const _hoisted_1 = { class: "lst_item" }
const _hoisted_2 = { class: "thumb badge_state" }
const _hoisted_3 = { class: "cont" }
const _hoisted_4 = { class: "name" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("li", _hoisted_1, [
    _createVNode("a", {
      onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (_ctx.$emit('moveToDetailPage')), ["prevent"])),
      href: "#",
      class: ["card_in", _ctx.statusClass]
    }, [
      _createVNode("span", _hoisted_2, [
        _createVNode("img", {
          src: _ctx.item.productImageUrl,
          alt: ""
        }, null, 8, ["src"])
      ]),
      _createVNode("div", _hoisted_3, [
        _renderSlot(_ctx.$slots, "refundableBadge", {}, undefined, true),
        _createVNode("strong", _hoisted_4, _toDisplayString(_ctx.item.productName), 1),
        _renderSlot(_ctx.$slots, "senderOrRecipent", {}, undefined, true),
        _renderSlot(_ctx.$slots, "ticketCount", {}, undefined, true),
        _renderSlot(_ctx.$slots, "validity", {}, undefined, true)
      ])
    ], 2),
    _renderSlot(_ctx.$slots, "cancelButton", {}, undefined, true)
  ]))
})